export const X402ErrorCodes = {
  INSUFFICIENT_FUNDS: {
    code: 'X402-001',
    message: 'USDC balance too low on Base',
    severity: 'user',
    recovery: 'fund_wallet'
  },
  INVALID_SIGNATURE: {
    code: 'X402-002',
    message: 'Payment signature invalid or expired',
    severity: 'fatal',
    recovery: null
  },
  PAYMENT_TIMEOUT: {
    code: 'X402-003',
    message: 'Invoice expired. Retry with new nonce.',
    severity: 'retryable',
    recovery: 'retry_with_nonce'
  },
  PAYMENT_CONFLICT: {
    code: 'X402-004',
    message: 'Concurrent payment attempt for same resource',
    severity: 'retryable',
    recovery: 'retry_with_backoff'
  },
  NETWORK_CONGESTION: {
    code: 'X402-005',
    message: 'Base mempool congested. Auto-retry in progress.',
    severity: 'retryable',
    recovery: 'retry_later'
  },
  UNKNOWN_402: {
    code: 'X402-999',
    message: 'Unrecognized 402 response. Inspect raw headers/body.',
    severity: 'debug',
    recovery: null
  }
} as const;

export type X402ErrorCode = keyof typeof X402ErrorCodes;